function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgAgility = function SvgAgility(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "-178.8 -80.2 320 250",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "M-27.4-55.2h-135.2v19.5     c0,26,21.1,47.1,47.1,47.1H18.5"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "M-98.1,11.4V31     c0,26,21.1,47.1,47.1,47.1H80"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "M87,144.8H11.1     c-26,0-47.1-21.1-47.1-47.1V78.1"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "M80,78.1"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "M87,74.9v69.9h15.4     c12.5,0,22.6-10.1,22.6-22.6V-32.4c0-12.6-10.2-22.9-22.9-22.9H-27.4c0,30.4,20.8,56.7,48.9,64C21.5,44.9,50.9,74.9,87,74.9z"
  }));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAgility, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/agility.d80ef621.svg";
export { ForwardRef as ReactComponent };